<template>
<div class="text-center">
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on }">
      <v-btn block color=primary @click="listarOsLiberacaoPorHora" dark v-on="on">
        <v-icon left>touch_app</v-icon>
        {{btnNome}}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline primary" primary-title>
        <span class="white--text">{{btnNome}}</span>
      </v-card-title>
      <v-card-text>
        <div v-show`="load">
          <div v-for="i in 5" :key="i">
            <v-skeleton-loader
              class="mx-auto"
              type="list-item-two-line">
            </v-skeleton-loader>
          </div>
        </div>
        <div v-show="!load">
         <v-virtual-scroll
          :bench="0"
          :items="list"
          height="300"
          item-height="64">
          <template v-slot="{ item }">
            <v-list-item :key="item">
               <v-list-item-content>
                <v-list-item-title v-text="item.Paciente"></v-list-item-title>
                <v-list-item-subtitle>OS: {{item.OS}}, Exames: {{item.Exames}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
        </div>
        <!-- <v-list two-line subheader>
          <v-list-item v-for="item in list" :key="item.title">
            <v-list-item-avatar>
              <v-icon :class="'grey lighten-1 white--text'" v-text="'person'"></v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="item.Paciente"></v-list-item-title>
              <v-list-item-subtitle>OS: {{item.OS}}, Exames: {{item.Exames}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list> -->
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="load" color="accent" text @click="dialog = false">
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import service from './../services/userservice'
export default {
  name: 'osLiberacaoPendente',
  props: {
    data: Object,
    btnNome: String
  },
  data () {
    return {
      dialog: false,
      load: false,
      list: []
    }
  },
  methods: {
    listarOsLiberacaoPorHora () {
      this.load = true
      console.log(this.data)
      service.osLiberacaoPendente(this.data).then(r => {
        if (r.status === 200) {
          this.list = r.data
        }
      }).finally(r => {
        this.load = false
      })
    }
  }
}
</script>
